// 猪线路
export const columnsPig = [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '猪场类型',
    dataIndex: 'farmType',
    width: 90,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '猪场性质',
    dataIndex: 'farmNature',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '猪场规模（头）',
    dataIndex: 'farmScale',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '所属工厂',
    dataIndex: 'factoryName',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '片区/聚落',
    dataIndex: 'settlementName',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '实证阶段',
    dataIndex: 'x2',
    width: 170,
    ellipsis: true,
    scopedSlots: { customRender: 'time' },
  },
  {
    title: '饲料品牌',
    dataIndex: 'feedBrand',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '料肉比',
    dataIndex: 'weightCostRatio',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed2' },
  },
  {
    title: '填报人',
    dataIndex: 'createUser',
    width: 90,
    ellipsis: true,
  },
  {
    title: '填报时间',
    dataIndex: 'createTime',
    width: 130,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '操作',
    dataIndex: 'x',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'x' },
  },
]
// 反刍
export const columnsRuminate = [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '畜种类型',
    dataIndex: 'animalType',
    width: 90,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '规模（头）',
    dataIndex: 'farmScale',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '所属工厂',
    dataIndex: 'factoryName',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '片区/聚落',
    dataIndex: 'settlementName',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '实证阶段',
    dataIndex: 'x2',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'time' },
  },
  {
    title: '饲料品牌',
    dataIndex: 'feedBrand',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '料肉比',
    dataIndex: 'weightCostRatio',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed2' },
  },
  {
    title: '填报人',
    dataIndex: 'createUser',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '填报时间',
    dataIndex: 'createTime',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '操作',
    dataIndex: 'x',
    width: 80,
    ellipsis: true,
    scopedSlots: { customRender: 'x' },
  },
]
// 肉禽
export const columnsMeat = [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '动物类型',
    dataIndex: 'animalType',
    width: 90,
    ellipsis: true,
  },
  {
    title: '养殖场性质',
    dataIndex: 'farmNature',
    width: 100,
    ellipsis: true,
  },
  {
    title: '饲喂阶段',
    dataIndex: 'feedPhase',
    width: 100,
    ellipsis: true,
  },
  {
    title: '饲料品牌',
    dataIndex: 'feedBrand',
    width: 100,
    ellipsis: true,
  },
  {
    title: '料重比',
    dataIndex: 'weightCostRatio',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed2' },
  },
  {
    title: '欧指',
    dataIndex: 'europeanEfficiencyIndex',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed2' },
  },
  {
    title: '时间',
    // dataIndex: 'time',
    width: 150,
    ellipsis: true,
    scopedSlots: { customRender: 'time' },
  },
  {
    title: '所属工厂',
    dataIndex: 'factoryName',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '片区/聚落',
    dataIndex: 'settlementName',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '填报人',
    dataIndex: 'createUser',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '填报时间',
    dataIndex: 'createTime',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '操作',
    dataIndex: 'x',
    width: 80,
    ellipsis: true,
    scopedSlots: { customRender: 'x' },
  },
]
// 蛋禽
export const columnsEgg = [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '动物类型',
    dataIndex: 'animalType',
    width: 90,
    ellipsis: true,
  },
  {
    title: '养殖场规模',
    dataIndex: 'farmScale',
    width: 100,
    ellipsis: true,
  },
  {
    title: '饲养模式',
    dataIndex: 'feedMode',
    width: 100,
    ellipsis: true,
  },
  {
    title: '日龄(天)',
    // dataIndex: '',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'dayAge' },
  },
  {
    title: '饲料品牌',
    dataIndex: 'feedBrand',
    width: 100,
    ellipsis: true,
  },
  {
    title: '料蛋比',
    dataIndex: 'weightCostRatio',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed2' },
  },
  {
    title: '产蛋率(%)',
    dataIndex: 'eggRate',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed2' },
  },
  {
    title: '所属工厂',
    dataIndex: 'factoryName',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '片区/聚落',
    dataIndex: 'settlementName',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '填报人',
    dataIndex: 'createUser',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '填报时间',
    dataIndex: 'createTime',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '操作',
    dataIndex: 'x',
    width: 80,
    ellipsis: true,
    scopedSlots: { customRender: 'x' },
  },
]
// 鱼
export const columnsFish = [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '池塘面积(亩)',
    dataIndex: 'pondArea',
    width: 90,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed2' },
  },
  {
    title: '水源情况',
    dataIndex: 'waterCondition',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '饵料系数',
    dataIndex: 'baitFactor',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed2' },
  },
  {
    title: '总产量(斤/亩)',
    dataIndex: 'totalOutput',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed2' },
  },
  {
    title: '饲料产量(斤/亩)',
    dataIndex: 'feedOutput',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed2' },
  },
  {
    title: '造肉成本(元/斤)',
    dataIndex: 'meatProductCost',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed2' },
  },
  {
    title: '放养次数(次)',
    dataIndex: 'stockingTimes',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '合计放养品种数(个)',
    dataIndex: 'totalStockingVarietyNum',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '合计放养数量(尾)',
    dataIndex: 'totalStockingNum',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed2' },
  },
  {
    title: '合计放养重量(斤)',
    dataIndex: 'totalStockingWeight',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed2' },
  },
  {
    title: '所属工厂',
    dataIndex: 'factoryName',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '片区/聚落',
    dataIndex: 'settlementName',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '填报人',
    dataIndex: 'createName',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '填报时间',
    dataIndex: 'createTime',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '操作',
    dataIndex: 'x',
    width: 80,
    ellipsis: true,
    scopedSlots: { customRender: 'x' },
  },
]
// 饲养信息
export const feedInfoColumns = [
  {
    title: '阶段',
    dataIndex: 'state',
    width: 120,
    ellipsis: true,
  },
  {
    title: '日期',
    dataIndex: 'day',
    width: 140,
    ellipsis: true,
  },
  {
    title: '日龄（天）',
    dataIndex: 'dayAge',
    width: 80,
    ellipsis: true,
    scopedSlots: { customRender: 'dayAge' },
  },
  {
    title: '均重（kg/头）',
    dataIndex: 'weight',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'weight' },
  },
  {
    title: '数量（头）',
    dataIndex: 'num',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'num' },
  },
]
export const inputfeedInfoColumns = [
  {
    title: '阶段',
    dataIndex: 'state',
    width: 120,
    ellipsis: true,
  },
  {
    dataIndex: 'day',
    width: 140,
    ellipsis: true,
    slots: { title: 'dayTitle' },
    scopedSlots: { customRender: 'day' },
  },
  {
    title: '日龄',
    dataIndex: 'dayAge',
    width: 80,
    ellipsis: true,
    scopedSlots: { customRender: 'dayAge' },
  },
  {
    dataIndex: 'weight',
    width: 100,
    ellipsis: true,
    slots: { title: 'weightTitle' },
    scopedSlots: { customRender: 'weight' },
  },
  {
    dataIndex: 'num',
    width: 100,
    ellipsis: true,
    slots: { title: 'numTitle' },
    scopedSlots: { customRender: 'num' },
  },
]
export const feedInfoRuminateColumns = [
  {
    title: '阶段',
    dataIndex: 'state',
    width: 120,
    ellipsis: true,
  },
  {
    title: '日期',
    dataIndex: 'day',
    width: 140,
    ellipsis: true,
  },
  {
    title: '均重（kg/头）',
    dataIndex: 'weight',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'weight' },
  },
  {
    title: '数量（头）',
    dataIndex: 'num',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'num' },
  },
]
export const inputFeedInfoRuminateColumns = [
  {
    title: '阶段',
    dataIndex: 'state',
    width: 120,
    ellipsis: true,
  },
  {
    dataIndex: 'day',
    width: 140,
    ellipsis: true,
    slots: { title: 'dayTitle' },
    scopedSlots: { customRender: 'day' },
  },
  {
    dataIndex: 'num',
    width: 100,
    ellipsis: true,
    slots: { title: 'numTitle' },
    scopedSlots: { customRender: 'num' },
  },
  {
    dataIndex: 'weight',
    width: 100,
    ellipsis: true,
    slots: { title: 'weightTitle' },
    scopedSlots: { customRender: 'weight' },
  },
]
export const feedInfoMeatColumns = [
  {
    title: '阶段',
    dataIndex: 'state',
    width: 120,
    ellipsis: true,
  },
  {
    title: '日期',
    dataIndex: 'day',
    width: 140,
    ellipsis: true,
  },
  {
    title: '数量（只）',
    dataIndex: 'num',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'num' },
  },
  {
    title: '总重（斤）',
    dataIndex: 'weight',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'weight' },
  }
]
export const feedStageColumns = [
  {
    title: '阶段',
    dataIndex: 'stageType',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'stageType' },
  },
  {
    title: '产品名称',
    dataIndex: 'productName',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'productName' },
  },
  {
    title: 'NHModel 名称',
    dataIndex: 'modelName',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'modelName' },
  },
  {
    title: 'NHModel 代码',
    dataIndex: 'modelCode',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'modelName' },
  },
  {
    title: '产品定位',
    dataIndex: 'productTarget',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'productTarget' },
  },
  {
    title: '饲料终端价格（元/吨）',
    dataIndex: 'feedTerminalPrice',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'feedTerminalPrice' },
  },
  {
    title: '总耗料量（kg）',
    dataIndex: 'feedCost',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'feedCost' },
  },
]
export const inputFeedStageColumns = [
  {
    title: '阶段',
    dataIndex: 'stageType',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'stageType' },
  },
  {
    dataIndex: 'productName',
    width: 130,
    ellipsis: true,
    slots: { title: 'productNameTitle' },
    scopedSlots: { customRender: 'productName' },
  },
  {
    dataIndex: 'productTarget',
    width: 100,
    ellipsis: true,
    slots: { title: 'productTargetTitle' },
    scopedSlots: { customRender: 'productTarget' },
  },
  {
    dataIndex: 'feedTerminalPrice',
    width: 100,
    ellipsis: true,
    slots: { title: 'feedTerminalPriceTitle' },
    scopedSlots: { customRender: 'feedTerminalPrice' },
  },
  {
    dataIndex: 'feedCost',
    width: 100,
    ellipsis: true,
    slots: { title: 'feedCostTitle' },
    scopedSlots: { customRender: 'feedCost' },
  },
]
export const feedStageMeatColumns = [
  {
    title: '阶段',
    dataIndex: 'stageType',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'stageType' },
  },
  {
    title: '产品名称',
    dataIndex: 'productName',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'productName' },
  },
  {
    title: 'NHModel 代码',
    dataIndex: 'modelCode',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'modelName' },
  },
  {
    title: 'NHModel 名称',
    dataIndex: 'modelName',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'modelName' },
  },
  {
    title: '饲料终端价格（元/吨）',
    dataIndex: 'feedTerminalPrice',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'feedTerminalPrice' },
  },
  {
    title: '总耗料量（斤）',
    dataIndex: 'feedCost',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'feedCost' },
  },
]
export const inputFeedStageMeatColumns = [
  {
    title: '阶段',
    dataIndex: 'stageType',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'stageType' },
  },
  {
    title: '产品名称',
    dataIndex: 'productName',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'productName' },
  },
  {
    title: '饲料终端价格（元/吨）',
    dataIndex: 'feedTerminalPrice',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'feedTerminalPrice' },
  },
  {
    title: '总耗料量（斤）',
    dataIndex: 'feedCost',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'feedCost' },
  },
]
export const feedingRuminateSituation = [
  {
    title: '饲料名称',
    dataIndex: 'name',
    width: 120,
    ellipsis: true,
  },
  {
    title: '重量(kg/天)',
    dataIndex: 'weight',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'weight' },
  },
  {
    title: '单价(元/kg)',
    dataIndex: 'price',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'price' },
  },
  {
    title: '干物质含量(%)',
    dataIndex: 'dryPercentage',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'dryPercentage' },
  },
]
export const feedInfoFishColumns = [
  {
    dataIndex: 'feedBrand',
    width: 120,
    ellipsis: true,
    slots: { title: 'feedBrandTitle' },
    scopedSlots: { customRender: 'feedBrand' },
  },
  {
    dataIndex: 'productName',
    width: 140,
    ellipsis: true,
    slots: { title: 'productNameTitle' },
    scopedSlots: { customRender: 'productName' },
  },
  {
    dataIndex: 'feedTerminalPrice',
    width: 100,
    ellipsis: true,
    slots: { title: 'feedTerminalPriceTitle' },
    scopedSlots: { customRender: 'feedTerminalPrice' },
  },
  {
    dataIndex: 'feedCost',
    width: 100,
    ellipsis: true,
    slots: { title: 'feedCostTitle' },
    scopedSlots: { customRender: 'feedCost' },
  },
  {
    title: '操作',
    dataIndex: 'x',
    width: 60,
    ellipsis: true,
    scopedSlots: { customRender: 'x' },
  },
]
export const formulaColumns = [
  {
    title: '配方名称',
    dataIndex: 'formulaName',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'formulaName' },
  },
  {
    title: '配方代码',
    dataIndex: 'formulaCode',
    width: 120,
    ellipsis: true,
  },
  {
    title: '动物类型',
    dataIndex: 'animalTypeName',
    width: 120,
    ellipsis: true,
  },
  {
    title: '配方模型',
    dataIndex: 'modelName',
    width: 120,
    ellipsis: true,
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: 120,
    ellipsis: true,
  },
]
export const materialSelectColumns = [
  {
    title: '原料名称',
    dataIndex: 'name',
    width: 120,
    ellipsis: true,
  },
  {
    title: 'DM（%）',
    dataIndex: 'percentage',
    width: 120,
    ellipsis: true,
  },
]
export const varietySelectColumns = [
  {
    title: '品种',
    dataIndex: 'varietyName',
    width: 120,
    ellipsis: true,
  },
  {
    title: '分类',
    dataIndex: 'varietyLabelName',
    width: 120,
    ellipsis: true,
  },
]
export const dailyFeedColumns = [
  {
    title: '饲料名称',
    dataIndex: 'name',
    width: 120,
    ellipsis: true,
  },
  {
    dataIndex: 'weight',
    width: 120,
    ellipsis: true,
    slots: { title: 'weightTitle' },
    scopedSlots: { customRender: 'weight' },
  },
  {
    dataIndex: 'price',
    width: 120,
    ellipsis: true,
    slots: { title: 'priceTitle' },
    scopedSlots: { customRender: 'price' },
  },
  {
    title: '干物质含量（%）',
    dataIndex: 'dryPercentage',
    width: 120,
    ellipsis: true,
  },
  {
    title: '操作',
    dataIndex: 'x',
    width: 60,
    ellipsis: true,
    scopedSlots: { customRender: 'x' },
  },
]
export const stockingInfoColumns = [
  {
    dataIndex: 'varietyName',
    width: 120,
    ellipsis: true,
    slots: { title: 'varietyTitle' },
    scopedSlots: { customRender: 'varietyName' },
  },
  {
    title: '类型',
    dataIndex: 'varietyLabelName',
    width: 120,
    ellipsis: true,
  },
  {
    dataIndex: 'stockingSpecification',
    width: 120,
    ellipsis: true,
    slots: { title: 'stockingSpecificationTitle' },
    scopedSlots: { customRender: 'stockingSpecification' },
  },
  {
    dataIndex: 'stockingNum',
    width: 120,
    ellipsis: true,
    slots: { title: 'stockingNumTitle' },
    scopedSlots: { customRender: 'stockingNum' },
  },
  {
    dataIndex: 'stockingWeight',
    width: 120,
    ellipsis: true,
    slots: { title: 'stockingWeightTitle' },
    scopedSlots: { customRender: 'stockingWeight' },
  },
]
export const proofingColumns = [
  {
    dataIndex: 'varietyName',
    width: 120,
    ellipsis: true,
    slots: { title: 'varietyTitle' },
    scopedSlots: { customRender: 'varietyName' },
  },
  {
    title: '类型',
    dataIndex: 'varietyLabelName',
    width: 120,
    ellipsis: true,
  },
  {
    dataIndex: 'proofingHarvestNum',
    width: 120,
    ellipsis: true,
    slots: { title: 'stockingNumTitle' },
    scopedSlots: { customRender: 'proofingHarvestNum' },
  },
  {
    dataIndex: 'proofingHarvestWeight',
    width: 120,
    ellipsis: true,
    slots: { title: 'stockingWeightTitle' },
    scopedSlots: { customRender: 'proofingHarvestWeight' },
  },
]
export const dieColumns = [
  {
    dataIndex: 'varietyName',
    width: 120,
    ellipsis: true,
    slots: { title: 'varietyTitle' },
    scopedSlots: { customRender: 'varietyName' },
  },
  {
    dataIndex: 'dieNum',
    width: 120,
    ellipsis: true,
    slots: { title: 'stockingNumTitle' },
    scopedSlots: { customRender: 'dieNum' },
  },
  {
    dataIndex: 'dieWeight',
    width: 120,
    ellipsis: true,
    slots: { title: 'stockingWeightTitle' },
    scopedSlots: { customRender: 'dieWeight' },
  },
]

// 我的实证排名
export const myRankColumns = [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '猪场类型',
    dataIndex: 'farmNature',
    width: 90,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '饲料品牌',
    dataIndex: 'feedBrand',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '实证阶段',
    dataIndex: 'x2',
    width: 170,
    ellipsis: true,
    scopedSlots: { customRender: 'time' },
  },
  {
    // title: '数据分类',
    dataIndex: 'labelName',
    width: 130,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
    slots: { title: 'customLabelName' },
  },
  {
    title: '料肉比',
    dataIndex: 'weightCostRatio',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed2' },
  },
  {
    // title: '料肉比同阶段排名',
    dataIndex: 'weightCostRatioRankWithStep',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'rank' },
    // sorter: (a, b) => a.name.length - b.name.length,
    slots: { title: 'customWeightCostRatioRank' },
  },
  {
    title: '造肉成本(元/kg)',
    dataIndex: 'mealProductCost',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed2' },
  },
  {
    // title: '造肉成本同阶段排名',
    dataIndex: 'mealProductCostRankWithStep',
    width: 160,
    ellipsis: true,
    scopedSlots: { customRender: 'rank' },
    slots: { title: 'customMealProductCostRank' },
  },
]

export default {stockingInfoColumns,proofingColumns,dieColumns}

